export const LOAD_CONTENT = 'LOAD_CONTENT';

export const SET_AQL_LIMIT_MAJOR = 'SET_AQL_LIMIT_MAJOR';
export const SET_AQL_LIMIT_MINOR = 'SET_AQL_LIMIT_MINOR';
export const SET_INSPECTION_LEVEL = 'SET_INSPECTION_LEVEL';
export const SET_MIN_ORDER_QTY = 'SET_MIN_ORDER_QTY';
